import { getWorkspaceLimits } from './user';
import { updateLoading } from './loading';

export const getSubscription = () => (dispatch) => {
  dispatch({
    type: 'GET_SUBSCRIPTION',
    payload: {
      endpoint: 'api/v1/subscriptions',
      method: 'GET',
      retries: 2,
    },
    components: ['subscriptionsLoader'],
  });
};

export const updateSubscription = (data, onSuccess, onFailed) => (dispatch) => {
  dispatch({
    type: 'UPDATE_SUBSCRIPTION',
    payload: {
      endpoint: 'api/v1/subscriptions/update',
      method: 'POST',
      body: data,
    },
    onSuccess: (subscription) => onSuccess(subscription),
    onFailed,
    components: ['updateSubscription'],
  });
};

export const updateSubscriptionStatus =
  ({ status, reason, period }, onSuccess = () => {}) =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_SUBSCRIPTION_STATUS',
      payload: {
        endpoint: 'api/v1/subscriptions/status',
        method: 'POST',
        body: {
          status,
          reason,
          period,
        },
        delayLoad: 0,
        showResponseError: true,
      },
      components: ['updateSubscriptionStatusLoader'],
      onSuccess: (data) => {
        dispatch(getWorkspaceLimits());
        onSuccess(data);
      },
    });
  };

export const cancelFastSpringSubscription =
  ({ data, onSuccess = () => {} }) =>
  (dispatch) => {
    dispatch({
      type: 'CANCEL_FASTSPRING_SUBSCRIPTION',
      payload: {
        method: 'POST',
        endpoint: `api/v1/subscriptions/fastspring/cancel/${data}`,
      },
      onSuccess,
    });
  };

export const encryptSensitiveData =
  ({ data, onSuccess = () => {} }) =>
  (dispatch) => {
    dispatch({
      type: 'ENCRYPT_FASTSPRING_DATA',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/subscriptions/fastspring/sensitive',
        body: data,
      },
      onSuccess,
    });
  };

export const setPauseForSubscription =
  ({ plan, onSuccess = () => {} }) =>
  (dispatch) => {
    dispatch({
      type: 'PAUSE_ACTIVE_SUBSCRIPTION',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/subscriptions/fastspring/pause',
        body: {
          plan,
        },
      },
      onSuccess,
    });
  };

export const setRedirectAfterFirstPay = (redirectStatus) => (dispatch) => {
  dispatch({
    type: 'REDIRECT_AFTER_FIRST_PAY',
    data: {
      redirectStatus,
    },
  });
};

export const setFastSpringData =
  (data = {}) =>
  (dispatch) => {
    dispatch({
      type: 'SET_FAST_SPRING_DATA',
      data,
    });
  };

export const setCancelSubscription =
  (data = {}) =>
  (dispatch) => {
    dispatch({
      type: 'SET_CANCEL_SUBSCRIPTION',
      data,
    });
  };

export const resetCancelSubscription = () => (dispatch) => {
  dispatch({
    type: 'RESET_CANCEL_SUBSCRIPTION',
    data: {},
  });
};

export const updateFSPayer = (payerType) => (dispatch) => {
  dispatch({
    type: 'UPDATE_FS_PAYER',
    payload: {
      method: 'PATCH',
      endpoint: 'api/v1/subscriptions/fastspring/payer',
      body: {
        payer: payerType,
      },
    },
    onSuccess: () => {
      dispatch(getSubscription());
    },
  });
};

export const updateSelectSubscriptionQuantity = (value) => (dispatch) => {
  dispatch({
    type: 'UPDATE_SELECT_SUBSCRIPTION_QUANTITY',
    data: {
      value,
    },
  });
};

export const purchaseSubscription =
  ({ emailsProduct, phonesProduct, onSuccess }) =>
  (dispatch) => {
    dispatch(updateLoading('purchaseSubscriptionLoader', true));
    dispatch({
      type: 'PURCHASE_SUBSCRIPTION',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/stripe/purchase',
        body: {
          emailsProduct,
          phonesProduct,
        },
        delayLoad: 0,
        showResponseError: true,
      },
      onSuccess: async (data) => {
        if (onSuccess) {
          await onSuccess(data);
        }
        dispatch(updateLoading('purchaseSubscriptionLoader', false));
      },
      onFailed: () => {
        dispatch(updateLoading('purchaseSubscriptionLoader', false));
      },
    });
  };

export const updatePhoneSearchPlan =
  (phoneSearchQuantity, onSuccess = () => {}) =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_PHONE_SEARCH_PLAN',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/subscriptions/phone-search/update',
        body: {
          phoneSearchQuantity,
        },
      },
      onSuccess,
    });
  };

export const updateStripeInfo =
  (onSuccess = () => {}) =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_STRIPE_INFO',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/stripe/update',
        delayLoad: 0,
        showResponseError: true,
      },
      components: ['updateStripeInfoLoader'],
      onSuccess,
    });
  };

export const getPurchaseStatus = () => (dispatch) => {
  dispatch({
    type: 'GET_PURCHASE_STATUS',
    payload: {
      endpoint: 'api/v1/stripe/purchase/status',
      method: 'GET',
    },
    components: ['getPurchaseStatusLoader'],
  });
};

export const purchaseCredits =
  ({ emailVerificationCreditsProduct, phoneNumbersCreditsProduct, onSuccess }) =>
  (dispatch) => {
    dispatch(updateLoading('purchaseCreditsLoader', true));
    dispatch({
      type: 'PURCHASE_CREDITS',
      payload: {
        method: 'POST',
        endpoint: 'api/v1/stripe/purchase/credits',
        body: {
          emailVerificationCreditsProduct,
          phoneNumbersCreditsProduct,
        },
        delayLoad: 0,
        showResponseError: true,
      },
      onSuccess: async (data) => {
        if (onSuccess) {
          await onSuccess(data);
        }
        dispatch(updateLoading('purchaseCreditsLoader', false));
      },
      onFailed: () => {
        dispatch(updateLoading('purchaseCreditsLoader', false));
      },
    });
  };
